
import * as React from 'react';
import styles from './api_target_badge.module.css';
import environmentService from '../services/environment.service';

const ApiTargetBadge = () => {
  if (!environmentService.hasApiOverride()) return null;

  const target = environmentService.getApiTarget();

  return (
    <div
      className={`${styles.badge} ${styles[target]}`}
      onClick={() => environmentService.cycleApiTarget()}
      title={`API: ${environmentService.getBaseUrl()} (click to switch)`}
    >
      API: {target}
    </div>
  );
};

export default ApiTargetBadge;
